import { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { useOutletContext } from "react-router";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

import "swiper/css";
import "swiper/css/pagination";

import { GrNext, GrPrevious } from "react-icons/gr";

import { ModernBannerContainer } from "../../styled/modernTheme";

const ModernBanner = ({ isExpanded = false }) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { cmpnyNo } = useOutletContext();
  const user = useSelector((state) => state?.user?.data[0]);

  const [banner, setBanner] = useState([]);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (cmpnyNo) {
      getMyBanner(cmpnyNo);
    }
  }, [cmpnyNo, isMobile]);

  const getMyBanner = async (cmpnyNo) => {
    try {
      const { data } = await axios.post("/api/firstSettingLoad", {
        cmpnyNo,
        delYn: "N",
      });

      const images = JSON.parse(data[isMobile ? "mbannerImgList" : "bannerImgList"] || "[]");
      const texts = JSON.parse(data[isMobile ? "mbannerUrl" : "bannerUrl"] || "[]");

      const banners = images.map((image, i) => ({
        image: imgHandler(image),
        text: texts[i] || "",
      }));

      setBanner(
        banners.length > 0
          ? banners
          : [
              { image: "/img/shopTheme/modern_banner_1.png" },
              { image: "/img/shopTheme/modern_banner_2.png" },
            ],
      );
    } catch (error) {
      console.error("배너 불러오기 실패:", error);
    }
  };

  const clickBanner = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  const handleSwiperButton = (isPrev) => {
    if (swiperInstance) {
      if (isPrev) {
        swiperInstance.slidePrev();
      } else {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <ModernBannerContainer className={isExpanded ? "expanded" : ""}>
      {banner && banner.length > 1 && (
        <>
          <button className="prev" onClick={() => handleSwiperButton(true)}>
            <GrPrevious />
          </button>
          <button className="next" onClick={() => handleSwiperButton(false)}>
            <GrNext />
          </button>
        </>
      )}
      {banner.length > 0 && (
        <Swiper
          className="banners"
          modules={[Pagination]}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          speed={1000}
          onSwiper={setSwiperInstance}
          autoplay={{
            delay: 500,
            disableOnInteraction: false,
          }}>
          {banner.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="bannerSlide" id={i} onClick={() => clickBanner(item.text)}>
                <img src={imgHandler(item.image)} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </ModernBannerContainer>
  );
};

export default ModernBanner;
